import { Component, input, output, signal } from '@angular/core';

import type { DenormalizedColumnEntity } from '@web/types';

import { GridCellWidthDirective } from './grid-cell-width.directive';

@Component({
    selector: 'web-grid-cell-resize',
    templateUrl: './web-grid-cell-resize.component.html',
    styleUrls: ['./web-grid-cell-resize.component.less'],
    imports: [GridCellWidthDirective],
})
export class WebGridCellResizeComponent {
    public columnCount = input<number>();
    public index = input<number>();
    public leftWidth = input.required<number>();
    public rightWidth = input.required<number>();
    public elementLeftId = input.required<string>();
    public elementRightId = input.required<string>();
    public columnLeft = input<DenormalizedColumnEntity>();
    public columnRight = input<DenormalizedColumnEntity>();

    public changeWidthToLeftEvent = output<void>();
    public changeWidthToRightEvent = output<void>();

    public get rightStyle(): number {
        return -15;
    }
}
